import _ from "lodash";
import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";
import { UNKNOWN, CommonExportUtil as Util } from "./CommonExportUtil";
import { Project } from "../../dao/Project";
import { Member } from "../../dao/Member";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";

export class F04_ExportManager {

  static Export_F04v0(common_form: UniForm, meta_table: UiMetaTable, answer_list: UniAnswer[], _Project: Project, sel_member_list: Member[]): F04_ExportData[] {
    let export_list: F04_ExportData[] = [];

    for (const ans of answer_list) {
      let rhf_data = ans.ConvertToCommonRhfData();

      let export_data: F04_ExportData = new F04_ExportData();

      //#region 帶入基本資料
      let sel_ans_member = sel_member_list.find(member => member.guid === ans.member_guid); //取得該ans的member資料

      export_data.填寫日期 = Util.填寫日期(ans);

      export_data.項次 = Util.項次();

      export_data.廠區 = Util.廠區(_Project);
      export_data.部門代號 = Util.部門代號();
      export_data.部門名稱 = Util.部門名稱(sel_ans_member);

      export_data.工號 = Util.工號(sel_ans_member);//XXX 改以 member 為準 Util.GetString(rhf_data, "m01.基本資訊●工號●input_1");
      export_data.姓名 = Util.姓名(sel_ans_member);//XXX 改以 member 為準 Util.GetString(rhf_data, "m01.基本資訊●姓名●input_1");
      export_data.健檢日期 = Util.健檢日期(sel_ans_member);

      export_data.性別 = Util.性別(ans, sel_ans_member);
      //#endregion
      export_data.請從以下說明中勾選最符合您目前的工作類型 = Util.OptionValue(meta_table, rhf_data, "m02.目前工作類型", UNKNOWN, null);
      export_data.請問您平均每天上班時使用電腦的時數為何 = Util.OptionValue(meta_table, rhf_data, "m02.平均使用電腦時數", UNKNOWN, null);
      export_data.工作適能的分數 = Util.OptionValue(meta_table, rhf_data, "m03.目前工作適能分數", UNKNOWN, null)

      let 狀態Map = {
        "非常好": "很好",
        "好": "好",
        "普通": "普通",
        "差": "差",
        "非常差": "很差",
      }
      export_data.依您目前工作所需要的體力需求來衡量您的工作適能 = Util.OptionValue(meta_table, rhf_data, "m03.工作所需體力需求", UNKNOWN, 狀態Map);
      export_data.依您目前工作所需要的心力需求來衡量您的工作適能 = Util.OptionValue(meta_table, rhf_data, "m03.工作所需心力需求", UNKNOWN, 狀態Map);

      let 有無Map = {
        "有": "有",
        "無": "無",
      }

      /* m04 */
      export_data.工作適能_有因事故導致的傷害 = Util.OptionValue(meta_table, rhf_data, "m04.有無事故傷害", UNKNOWN, 有無Map);
      export_data.工作適能_有因事故導致的傷害 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_有因事故導致的傷害, "m04.傷害類別");

      export_data.工作適能_肌肉骨骼疾病 = Util.OptionValue(meta_table, rhf_data, "m04.有無肌肉骨骼疾病", UNKNOWN, 有無Map);
      export_data.工作適能_肌肉骨骼疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_肌肉骨骼疾病, "m04.肌肉骨骼疾病類別");

      export_data.工作適能_心血管疾病 = Util.OptionValue(meta_table, rhf_data, "m04.有無心血管疾病", UNKNOWN, 有無Map);
      export_data.工作適能_心血管疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_心血管疾病, "m04.心血管疾病類別");

      /* m05 */
      export_data.工作適能_呼吸系統疾病 = Util.OptionValue(meta_table, rhf_data, "m05.有無呼吸系統疾病", UNKNOWN, 有無Map);
      export_data.工作適能_呼吸系統疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_呼吸系統疾病, "m05.呼吸系統疾病類別");

      export_data.工作適能_心理健康問題疾病 = Util.OptionValue(meta_table, rhf_data, "m05.有無心理健康疾病", UNKNOWN, 有無Map);
      export_data.工作適能_心理健康問題疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_心理健康問題疾病, "m05.心理健康疾病類別");

      export_data.工作適能_神經系統和感覺器官疾病 = Util.OptionValue(meta_table, rhf_data, "m05.有無神經系統疾病", UNKNOWN, 有無Map);
      export_data.工作適能_神經系統和感覺器官疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_神經系統和感覺器官疾病, "m05.神經系統疾病類別");

      /* m06 */
      export_data.工作適能_消化器官疾病 = Util.OptionValue(meta_table, rhf_data, "m06.有無消化疾病", UNKNOWN, 有無Map);
      export_data.工作適能_消化器官疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_消化器官疾病, "m06.消化疾病類別");

      export_data.工作適能_生殖泌尿器官疾病 = Util.OptionValue(meta_table, rhf_data, "m06.有無生殖器官疾病", UNKNOWN, 有無Map);
      export_data.工作適能_生殖泌尿器官疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_生殖泌尿器官疾病, "m06.生殖器官疾病類別");

      export_data.工作適能_皮膚疾病 = Util.OptionValue(meta_table, rhf_data, "m06.有無皮膚疾病", UNKNOWN, 有無Map);
      export_data.工作適能_皮膚疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_皮膚疾病, "m06.皮膚疾病類別");

      /* m07 */
      export_data.工作適能_腫瘤 = Util.OptionValue(meta_table, rhf_data, "m07.有無腫瘤", UNKNOWN, 有無Map);
      export_data.工作適能_腫瘤 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_腫瘤, "m07.腫瘤類別");

      export_data.工作適能_內分泌或代謝疾病 = Util.OptionValue(meta_table, rhf_data, "m07.有無內分泌代謝疾病", UNKNOWN, 有無Map);
      export_data.工作適能_內分泌或代謝疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_內分泌或代謝疾病, "m07.內分泌代謝疾病類別");

      export_data.工作適能_血液疾病 = Util.OptionValue(meta_table, rhf_data, "m07.有無血液疾病", UNKNOWN, 有無Map);
      export_data.工作適能_血液疾病 = GetDetailsIfYes(meta_table, rhf_data, export_data.工作適能_血液疾病, "m07.血液疾病類別");

      /* m08 */
      export_data.工作適能_先天缺陷 = Util.OptionValue(meta_table, rhf_data, "m08.有無天生缺陷", UNKNOWN, 有無Map);
      if (export_data.工作適能_先天缺陷 === "有") {
        export_data.工作適能_先天缺陷 = Util.GetString(rhf_data, "m08.有無天生缺陷●有●input_1");
      }

      export_data.工作適能_其他問題或疾病 = Util.OptionValue(meta_table, rhf_data, "m08.有無其他疾病", UNKNOWN, 有無Map);
      if (export_data.工作適能_其他問題或疾病 === "有") {
        export_data.工作適能_其他問題或疾病 = Util.GetString(rhf_data, "m08.有無其他疾病●有●input_1");
      }

      /* 六、以您的健康狀況衡量，您認為目前的工作還可以繼續從事兩年嗎？ */
      export_data.您的疾病或傷害對您工作的影響為何 = Util.OptionValue(meta_table, rhf_data, "m09.疾病對工作影響", UNKNOWN, null);
      export_data.您的疾病或傷害對您工作的影響為何 = export_data.您的疾病或傷害對您工作的影響為何
        .replaceAll("1. ", "")
        .replaceAll("2. ", "")
        .replaceAll("3. ", "")
        .replaceAll("4. ", "")
        .replaceAll("5. ", "")
        .replaceAll("6. ", "");// 先這樣，但可能會比較慢，再觀察

      export_data.最近12個月您曾經因為健康問題整天請假共多少天 = Util.OptionValue(meta_table, rhf_data, "m10.因健康問題請假", UNKNOWN, null);
      export_data.以您的健康狀況衡量您目前的工作還可以繼續從事兩年 = Util.OptionValue(meta_table, rhf_data, "m11.繼續從事兩年", UNKNOWN, null);

      /* 七、請依據您最近的感受回答下列各題 */
      export_data.您最近的日常生活都能樂在其中嗎 = Util.OptionValue(meta_table, rhf_data, "m12.樂於日常活動", UNKNOWN, null);
      export_data.您最近是否很有活力且反應敏銳嗎 = Util.OptionValue(meta_table, rhf_data, "m12.活力且反應敏銳", UNKNOWN, null);
      export_data.您最近對未來充滿希望嗎 = Util.OptionValue(meta_table, rhf_data, "m12.充滿希望", UNKNOWN, null);


      // export_data.工作適能_有因事故導致的傷害 = Util.OptionValue(meta_table, rhf_data, "m04.有無事故傷害", "(XXXX)",
      //   {
      //     "無":"無",
      //     "有":
      //   }
      // )



      // TODO GetTrueFalse(true_val, false_val, undefined_val)...

      export_list.push(export_data);
    }

    return export_list;
  }

}

function GetDetailsIfYes(meta_table: UiMetaTable, rhf_data: any, yes_or_no: string, checks_rhf_name: string): string {
  if (yes_or_no === "無" || yes_or_no === UNKNOWN) {
    return yes_or_no;// 不須補充明細，回傳 無 或 無法解析 即可
  }

  if (yes_or_no !== "有") {
    throw new_ErrorAlert("5468431 應該要是 有 或 無 !!!");
  }

  let metas = Util.GetMeta_SelChecks(meta_table, rhf_data, checks_rhf_name);

  let items: string[] = Util.GetCheckLabels_WithInput(meta_table, rhf_data, metas);


  return items.join("; ");
}


export class F04_ExportData {
  填寫日期 = "";

  項次 = "";

  廠區 = "";
  部門代號 = "";
  部門名稱 = "";// 原本叫做 "部門"

  工號 = "";
  姓名 = "";
  健檢日期 = "";

  性別 = "";// 多加的欄位

  //----------------------------------

  請從以下說明中勾選最符合您目前的工作類型 = "";
  請問您平均每天上班時使用電腦的時數為何 = "";
  工作適能的分數 = "";
  依您目前工作所需要的體力需求來衡量您的工作適能 = ""
  依您目前工作所需要的心力需求來衡量您的工作適能 = "";

  /* m04 */
  工作適能_有因事故導致的傷害 = "";
  工作適能_肌肉骨骼疾病 = "";
  工作適能_心血管疾病 = "";

  /* m05 */
  工作適能_呼吸系統疾病 = "";
  工作適能_心理健康問題疾病 = "";
  工作適能_神經系統和感覺器官疾病 = "";

  /* m06 */
  工作適能_消化器官疾病 = "";
  工作適能_生殖泌尿器官疾病 = "";
  工作適能_皮膚疾病 = "";

  /* m07 */
  工作適能_腫瘤 = "";
  工作適能_內分泌或代謝疾病 = "";
  工作適能_血液疾病 = "";

  /* m08 */
  工作適能_先天缺陷 = "";
  工作適能_其他問題或疾病 = "";

  /* 六、以您的健康狀況衡量，您認為目前的工作還可以繼續從事兩年嗎？ */
  您的疾病或傷害對您工作的影響為何 = "";
  最近12個月您曾經因為健康問題整天請假共多少天 = "";
  以您的健康狀況衡量您目前的工作還可以繼續從事兩年 = "";

  /* 七、請依據您最近的感受回答下列各題 */
  您最近的日常生活都能樂在其中嗎 = "";
  您最近是否很有活力且反應敏銳嗎 = "";
  您最近對未來充滿希望嗎 = "";

}



